import TypeLeger from "../../../../../components/categories/siakad/lms/leger/subpage/type_leger/Home";
export default function Home() {
  
  return (
    <TypeLeger />
  );
}
